const ALLOWED_FORMATTING_TAGS = new Set(["STRONG", "B", "EM", "I", "BR"]);

const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const serializeNode = (node) => {
  if (node.nodeType === Node.TEXT_NODE) {
    return escapeHtml(node.textContent.replace(/\u00a0/g, " "));
  }

  if (node.nodeType !== Node.ELEMENT_NODE) return "";
  if (node.tagName === "SCRIPT" || node.tagName === "STYLE") return "";

  const children = Array.from(node.childNodes).map(serializeNode).join("");
  if (!ALLOWED_FORMATTING_TAGS.has(node.tagName)) return children;
  if (node.tagName === "BR") return "<br>";
  if (node.tagName === "STRONG" || node.tagName === "B") {
    return children ? `<strong>${children}</strong>` : "";
  }
  return children ? `<em>${children}</em>` : "";
};

export const sanitizeRichText = (value) => {
  const template = document.createElement("template");
  template.innerHTML = String(value || "");
  return Array.from(template.content.childNodes).map(serializeNode).join("");
};

export const normalizeRichText = (value) => {
  const source = String(value || "");

  if (/<\/?[a-z][\s\S]*>/i.test(source)) {
    return sanitizeRichText(source);
  }

  const escaped = escapeHtml(source)
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/\*([^*]+)\*/g, "<em>$1</em>")
    .replace(/\r?\n/g, "<br>");

  return sanitizeRichText(escaped);
};

export const buildEditorHtml = (fields, values) =>
  fields
    .map((field) => {
      const key = escapeHtml(field.key);
      const content = normalizeRichText(values?.[field.key]) || "<br>";
      return `<p data-main-page-field="${key}">${content}</p>`;
    })
    .join("");

export const extractEditorValues = (html, fields) => {
  const template = document.createElement("template");
  template.innerHTML = String(html || "");
  const blocks = new Map(
    Array.from(template.content.querySelectorAll("[data-main-page-field]")).map(
      (element) => [element.getAttribute("data-main-page-field"), element]
    )
  );

  return fields.reduce((result, field) => {
    const block = blocks.get(field.key);
    const content = block ? sanitizeRichText(block.innerHTML) : "";
    result[field.key] = content === "<br>" ? "" : content.trim();
    return result;
  }, {});
};
